import { render, staticRenderFns } from "./DeptUserInfo.vue?vue&type=template&id=6adc63d1&scoped=true&"
import script from "./DeptUserInfo.vue?vue&type=script&lang=js&"
export * from "./DeptUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./DeptUserInfo.vue?vue&type=style&index=0&id=6adc63d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adc63d1",
  null
  
)

export default component.exports